import { Col, Form, Input, Row, Select, Table } from "antd";
import { useEffect, useState } from "react";
import { ContentBox } from "../../../components/layout/content";
import { LoginedLayout } from "../../../components/layout/loginLayout";
import { ItemData } from "../../../Data/searchItem";
import { GET } from "../../../services";
import { CHECKER_GET_SKU } from "../../../services/path";

const columns = [
  {
    title: <div style={{ textAlign: "center" }}>No.</div>,
    dataIndex: "run_number",
    key: "run_number",
    sorter: (a: ItemData, b: ItemData) => a.run_number - b.run_number,
    render: (text: number) => (
      <div style={{ textAlign: "center" }}>
        <span>{text}</span>
      </div>
    ),
  },
  {
    title: <div style={{ textAlign: "center" }}>SKU ID</div>,
    dataIndex: "item_id",
    key: "item_id",
    sorter: (a: ItemData, b: ItemData) => {
      const A = a.item_id ?? "";
      const B = b.item_id ?? "";
      return A.localeCompare(B);
    },
    render: (text: string) => (
      <div style={{ textAlign: "start" }}>
        <span>{text}</span>
      </div>
    ),
  },
  {
    title: <div style={{ textAlign: "center" }}>On Order</div>,
    dataIndex: "on_order",
    key: "on_order",
    sorter: (a: ItemData, b: ItemData) => a.on_order - b.on_order,
    render: (text: number) => (
      <div style={{ textAlign: "center" }}>
        <span>{text}</span>
      </div>
    ),
  },
  {
    title: <div style={{ textAlign: "center" }}>ยอดสั่งซื้อ online</div>,
    dataIndex: "total_reserve",
    key: "total_reserve",
    sorter: (a: ItemData, b: ItemData) => a.total_reserve - b.total_reserve,
    render: (text: number) => (
      <div style={{ textAlign: "center" }}>
        <span>{text}</span>
      </div>
    ),
  },
  {
    title: <div style={{ textAlign: "center" }}>ยอดคงเหลือ</div>,
    dataIndex: "avali_lordered",
    key: "avali_lordered",
    sorter: (a: ItemData, b: ItemData) => a.avali_lordered - b.avali_lordered,
    render: (text: number) => (
      <div style={{ textAlign: "center" }}>
        <span>{text}</span>
      </div>
    ),
  },
];

const SearchItem = () => {
  const [data, setData] = useState<ItemData[]>([]);
  const [filteredData, setFilteredData] = useState(data);
  const [searchValue, setSearchValue] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(25);
  const [loading, setLoading] = useState(false);
  const handlePageSizeChange = (size: number) => {
    setPageSize(size);
    setCurrentPage(1);
  };

  const pageOptions = ["10", "25", "50", "100"];
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const apiEndpoint = CHECKER_GET_SKU();
        const result = await GET(apiEndpoint);
        setData(result);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleSearch = (value: string) => {
    setSearchValue(value.trim());
  };

  useEffect(() => {
    const trimmedSearchValue = searchValue || "";
    if (!trimmedSearchValue) {
      setFilteredData(data);
    } else {
      const filteredList = data.filter((item) =>
        item.item_id.toUpperCase().includes(searchValue.toUpperCase()),
      );
      setFilteredData(filteredList);
    }
  }, [searchValue, data]);

  return (
    <div>
      <LoginedLayout>
        <ContentBox>
          <div
            style={{
              marginBottom: "16px",
              borderBottom: "1px solid #e8e8e8",
              paddingBottom: "8px",
            }}
          >
            <h2 style={{ marginBottom: "8px" }}>Products</h2>
          </div>
          <Form>
            <Row gutter={[16, 16]} style={{ marginBottom: "15px" }}>
              <Col xs={14} sm={12} md={14} lg={18} xl={18}>
                <span>Show: </span>
                <Select
                  value={pageSize.toString()}
                  onChange={(value) => handlePageSizeChange(parseInt(value))}
                >
                  {pageOptions.map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </Select>
              </Col>
              <Col xs={10} sm={12} md={10} lg={6} xl={6}>
                <Input.Search
                  placeholder="Enter SKU ID"
                  onSearch={handleSearch}
                  value={searchValue}
                  onChange={(e) => setSearchValue(e.target.value)}
                />
              </Col>
            </Row>
          </Form>
          <Table
            columns={columns}
            dataSource={filteredData}
            loading={loading}
            scroll={{ x: 1500 }}
            pagination={{
              position: ["bottomRight"],
              pageSize: pageSize,
              showSizeChanger: true,
              showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
              onShowSizeChange: (_, size) => handlePageSizeChange(size),
              current: currentPage,
              onChange: (page) => setCurrentPage(page),
              total: filteredData.length,
            }}
          />
        </ContentBox>
      </LoginedLayout>
    </div>
  );
};

export default SearchItem;
